import { parseIframeComponentCore } from './component.iframe.core.js';

const parseIframeHtmlComponent = (node) => {
  const src = node.getAttribute("src");
  const coreConfig = parseIframeComponentCore(node);
  if (!src || !coreConfig) {
    return null;
  }
  const width = parseInt(node.getAttribute("width") || "0", 10) || 600;
  const height = parseInt(node.getAttribute("height") || "0", 10) || 400;
  const displayData = {
    src,
    proportions: { width, height },
    minSize: void 0,
    maxSize: void 0,
    fixedHeight: false
  };
  if (node.getAttribute("data-responsive") === "false") {
    displayData.maxSize = { width, height };
    displayData.minSize = { width, height };
  }
  if (node.getAttribute("data-fixed-height") === "true") {
    if (displayData.maxSize) {
      displayData.maxSize.height = displayData.proportions.height;
    }
    if (displayData.minSize) {
      displayData.minSize.height = displayData.proportions.height;
    }
    displayData.fixedHeight = true;
  }
  return {
    ...coreConfig,
    options: {
      ...coreConfig.options,
      autoActivate: true
    },
    displayData
  };
};

export { parseIframeHtmlComponent };
//# sourceMappingURL=component.iframe.html.js.map
